import { render } from "./CommonSystemNoticeComponent.vue?vue&type=template&id=9596c888&scoped=true"
import script from "./CommonSystemNoticeComponent.vue?vue&type=script&lang=js"
export * from "./CommonSystemNoticeComponent.vue?vue&type=script&lang=js"

import "./CommonSystemNoticeComponent.vue?vue&type=style&index=0&id=9596c888&lang=scss"
import "./CommonSystemNoticeComponent.vue?vue&type=style&index=1&id=9596c888&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9596c888"],['__file',"src/views/h5/common/home/components/top/CommonSystemNoticeComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9596c888"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9596c888', __exports__)) {
    api.reload('9596c888', __exports__)
  }
  
  module.hot.accept("./CommonSystemNoticeComponent.vue?vue&type=template&id=9596c888&scoped=true", () => {
    api.rerender('9596c888', render)
  })

}


export default __exports__